import { Badge } from '../../ui/badge';
import { Section } from '../ihaleler/IhaleDetailSections';
import { ODENEK_DURUM_TONE } from './detayOrtak';

export { Section };

export const grid = 'grid grid-cols-2 md:grid-cols-3 gap-3 text-sm';

export function Field({ label, value, testId, className = '' }) {
  return (
    <div className={className} data-testid={testId}>
      <span className="text-gray-500">{label}:</span> <span className="text-white ml-2 break-words">{value || '-'}</span>
    </div>
  );
}

export function Money({ label, value, testId, tone = '' }) {
  return (
    <div className={`flex justify-between gap-3 bg-gray-800/50 p-2 rounded ${tone}`} data-testid={testId}>
      <span className="text-gray-400">{label}:</span> <span className="text-white font-medium text-right">{value || '-'}</span>
    </div>
  );
}

export function DurumRozeti({ value, label, testId, toneMap = ODENEK_DURUM_TONE }) {
  if (!value) return <span className="text-white ml-2">-</span>;
  return <Badge className={`ml-2 border ${toneMap[value] || 'bg-gray-700 text-gray-200 border-gray-600'}`} data-testid={testId}>{label || value}</Badge>;
}

export function RozetListesi({ items, emptyText = '-', testId }) {
  if (!items?.length) return <span className="text-white ml-2">{emptyText}</span>;
  return (
    <div className="flex flex-wrap gap-1.5 mt-1.5" data-testid={testId}>
      {items.map((it, idx) => <Badge key={idx} className="bg-gray-800 text-gray-200 border-gray-700">{it}</Badge>)}
    </div>
  );
}
